module.exports = __webpack_public_path__ + "img/img0203.590b9090.png";